// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__7tmi4","text":"styles_text__piwpS","cta":"styles_cta__t3KaO","longCaption":"styles_longCaption__mDM9J"};